var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#000000;stroke-linecap:round;stroke-width:1.5px;}.cls-1{stroke-linejoin:round;}.cls-2{stroke-linejoin:bevel;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-users-info"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3,21l.79-2.88C5.1,13.39,8.55,11,12,11"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 12,
    cy: 5.98,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 17,
    cy: 18,
    r: 5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17,
    y1: 17.34,
    x2: 17,
    y2: 20.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17,
    y1: 15.6,
    x2: 17,
    y2: 15.51
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.f05bc67458fe212c572241e5ffdc97fc.svg";
export { ForwardRef as ReactComponent };